import { set } from 'date-fns';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addVendor, addAllVendors, updateVendor } from '../Redux/Reducer/vendorsReducer';
import { toast } from 'react-toastify';
import AxiosService from 'utils/AxiosService';
import { useNavigate } from 'react-router-dom';

function UseVendorHook() {
  let [createEmpLoading, setCreateEmpLoading] = useState(false);
  let dispatch = useDispatch();
  let navigate = useNavigate();

  // ✅ CREATE VENDOR
  const createVendor = async (data) => {
    setCreateEmpLoading(true);

    let val = {
      name: data?.name,
      email: data?.email,
      mobile: data?.mobile,
      address: data?.address,
      active: data?.active,
      role: "vendor",
      vendorDetails: {
        businessName: data?.vendorDetails?.businessName,
        access_token: data?.vendorDetails?.access_token,
        instanceId: data?.vendorDetails?.instanceId,
        ownerNumber: data?.vendorDetails?.ownerNumber,
        country: data?.vendorDetails?.country || "91", // ✅ Added country field
        thankYouMessage: data?.vendorDetails?.thankYouMessage || "",
        logoUrl: data?.vendorDetails?.logoUrl || "",
        currency: data?.vendorDetails?.currency || "INR",
        // ✅ Subscription details
        subscription: {
          plan: data?.vendorDetails?.subscription?.plan || "free",
          paymentMethod: data?.vendorDetails?.subscription?.paymentMethod || "none",
          amount: data?.vendorDetails?.subscription?.amount || 0,
          transactionId: data?.vendorDetails?.subscription?.transactionId || null,
          status: data?.vendorDetails?.subscription?.status || "trial",
        },
      },
    };

    try {
      let res = await AxiosService.post('/auth/createVendor', val);

      if (res.status === 201) {
        toast.success(res.data.message);
        dispatch(addVendor(res?.data.vendor));
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setCreateEmpLoading(false);
    }
  };

  // ✅ GET ALL VENDORS
  const getAllVendors = async () => {
    setCreateEmpLoading(true);
    try {
      let res = await AxiosService.get('/admin/vendors');
      if (res.status === 200) {
        dispatch(addAllVendors(res?.data));
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'Failed to load vendors');
    } finally {
      setCreateEmpLoading(false);
    }
  };

  // ✅ EDIT VENDOR
  const editVendor = async (data) => {
    setCreateEmpLoading(true);

    let val = {
      name: data?.name,
      email: data?.email,
      mobile: data?.mobile,
      address: data?.address,
      active: data?.active,
      role: "vendor",
      vendorDetails: {
        businessName: data?.vendorDetails?.businessName,
        access_token: data?.vendorDetails?.access_token,
        instanceId: data?.vendorDetails?.instanceId,
        ownerNumber: data?.vendorDetails?.ownerNumber,
        country: data?.vendorDetails?.country || "91", // ✅ Added country field
        thankYouMessage: data?.vendorDetails?.thankYouMessage || "",
        logoUrl: data?.vendorDetails?.logoUrl || "",
        currency: data?.vendorDetails?.currency || "INR",
        subscription: {
          plan: data?.vendorDetails?.subscription?.plan || "free",
          paymentMethod: data?.vendorDetails?.subscription?.paymentMethod || "none",
          amount: data?.vendorDetails?.subscription?.amount || 0,
          transactionId: data?.vendorDetails?.subscription?.transactionId || null,
          status: data?.vendorDetails?.subscription?.status || "trial",
        },
      },
    };

    try {
      let res = await AxiosService.put(`/auth/updateVendor/${data?._id}`, val);
      if (res.status === 200) {
        toast.success(res.data.message);
        dispatch(updateVendor(res?.data?.vendor));
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setCreateEmpLoading(false);
    }
  };

  // ✅ UPDATE MESSAGE TEMPLATE
  const updateMessageTemplate = async (data) => {
    try {
      let res = await AxiosService.put(`/auth/updateMessageThanku`, data);
      if (res.status === 200) {
        toast.success(res.data.message);
        const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
        localStorage.setItem('user', JSON.stringify({
          ...storedUser,
          ...res?.data?.vendor,
        }));
        navigate(-1);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update message');
    }
  };

  return { createEmpLoading, createVendor, getAllVendors, editVendor, updateMessageTemplate };
}

export default UseVendorHook;
